import { i18next } from '@yola/ws-sdk';

const getDefaultPlatformOption = () => ({ label: i18next.t('All styles'), value: 'all' });

export default getDefaultPlatformOption;
